import { HttpErrorResponse } from '@angular/common/http';

import { User } from '../../../shared/models/user/user.model';

/**
 * User error state interface
 */
export interface UserErrorState {
    name: string;
    error: HttpErrorResponse;
}

/**
 * User state interface
 */
export interface UserState {
    /**
     * Current Authenticated User
     */
    current?: User;
    /**
     * User api errors that have occurred during user session.
     */
    errors?: Array<UserErrorState>;
}

/**
 * Initial user state
 */
export const initialUserState: UserState = {
    current: null,
    errors: [],
};
